module.exports = __webpack_public_path__ + "img/HC2023-01.55b48e26.jpg";